import React, { forwardRef } from "react";
import { TextField } from "@material-ui/core";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomDateInput = (props: any, ref: any) => {
  const { onClick, value, clearSelectedRange, label, ...rest } = props;

  const onKeyDownHandler = (evt: React.KeyboardEvent<HTMLDivElement>) => {
    if (evt.key === "Backspace" || evt.key === "Delete") {
      clearSelectedRange && clearSelectedRange();
    }
  };

  return (
    <TextField
      id="outlined-basic"
      label={label}
      variant="outlined"
      onFocus={onClick}
      value={value}
      ref={ref}
      autoComplete="off"
      {...rest}
      // Handle delete when selecting range
      onKeyDown={onKeyDownHandler}
    />
  );
};

export default forwardRef(CustomDateInput);
